import { Cart } from "./cart";
import { CartItem, RetailCartItem, RetailCartValue } from "./types";
import { LocalStorageKey } from "@/utils/storageKeys";
import { CartType } from "@/constants/enum";

/**
 * Cart implementation specifically for the Retail vertical.
 *
 * Handles logic unique to retail items, such as managing product variants.
 *
 * @extends {Cart<RetailCartItem>}
 */
export class RetailCart extends Cart<RetailCartItem> {
  // Retail-specific properties or methods can be added here in later phases

  /**
   * Creates a new RetailCart instance.
   *
   * @param data - Optional initial data.
   */
  constructor(data?: any) {
    super(data);
    // Initialize retail-specific properties if any
  }

  // Override toJSON to include the type discriminator
  toJSON(): any {
    return {
      ...super.toJSON(),
      type: CartType.RETAIL_CART,
    };
  }

  // Static method to re-hydrate from a plain object
  static fromJSON(data: any): RetailCart {
    return new RetailCart(data);
  }

  static addItem(item: RetailCartValue): void {
    const cartItem: CartItem = {
      key: item.cartId,
      value: item,
    } as CartItem;
    this._addToStorage(LocalStorageKey.RETAIL_CART, cartItem);
  }

  static getItems(): RetailCartItem[] {
    return this._getFromStorage<RetailCartItem>(LocalStorageKey.RETAIL_CART);
  }

  static clear(): void {
    this._clearStorage(LocalStorageKey.RETAIL_CART);
  }

  static removeItem(cartId: string): void {
    this._removeFromStorage(LocalStorageKey.RETAIL_CART, cartId);
  }
}
